(() => {
  if (window.skinEliteHalloweenCountdownLoaded) return;
  window.skinEliteHalloweenCountdownLoaded = true;
  const activeCountdowns = new WeakSet();
  const inMemoryDeadlines = new Map();
  window.skinEliteHalloweenCountdown = Object.freeze({
    getDeadline: (key) => inMemoryDeadlines.get(key),
  });

  function initializeCountdown(root) {
    if (activeCountdowns.has(root)) return;
    const clock = root.querySelector('[data-countdown-clock]');
    const hours = root.querySelector('[data-countdown-hours]');
    const minutes = root.querySelector('[data-countdown-minutes]');
    const seconds = root.querySelector('[data-countdown-seconds]');
    const key = root.dataset.countdownKey;
    const duration = Number(root.dataset.duration) * 1000;
    if (!clock || !minutes || !seconds || !key || !Number.isFinite(duration) || duration <= 0) return;
    activeCountdowns.add(root);

    let deadline = inMemoryDeadlines.get(key);
    if (!deadline) {
      try {
        const stored = Number(localStorage.getItem(key));
        if (Number.isFinite(stored) && stored > 0) deadline = stored;
      } catch (_) {
        // Storage may be unavailable; the current page still counts down.
      }
      if (!deadline) {
        deadline = Date.now() + duration;
        try { localStorage.setItem(key, String(deadline)); } catch (_) {}
      }
      inMemoryDeadlines.set(key, deadline);
    }

    let intervalId;
    let previousActive;
    function updateCountdown() {
      if (!root.isConnected) {
        clearInterval(intervalId);
        document.removeEventListener('visibilitychange', updateCountdown);
        return;
      }
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      const active = remaining > 0;
      if (active !== previousActive) {
        previousActive = active;
        window.dispatchEvent(new CustomEvent('skin-elite:countdown-state', {
          detail: { key, deadline, active },
        }));
      }
      if (remaining === 0) {
        clock.hidden = true;
        root.dataset.countdownComplete = 'true';
        clearInterval(intervalId);
        document.removeEventListener('visibilitychange', updateCountdown);
        return;
      }
      const remainingHours = Math.floor(remaining / 3600);
      // Keep the previous MM:SS markup working while theme assets roll out.
      const remainingMinutes = hours ? Math.floor((remaining % 3600) / 60) : Math.floor(remaining / 60);
      const remainingSeconds = remaining % 60;
      if (hours) hours.textContent = String(remainingHours).padStart(2, '0');
      minutes.textContent = String(remainingMinutes).padStart(2, '0');
      seconds.textContent = String(remainingSeconds).padStart(2, '0');
      const hoursLabel = hours ? `${remainingHours} hours, ` : '';
      clock.setAttribute('aria-label', `${hoursLabel}${remainingMinutes} minutes and ${remainingSeconds} seconds remaining`);
      clock.hidden = false;
    }

    updateCountdown();
    if (root.dataset.countdownComplete !== 'true') {
      intervalId = setInterval(updateCountdown, 1000);
      document.addEventListener('visibilitychange', updateCountdown);
    }
  }

  function initializeAll() {
    document.querySelectorAll('[data-skin-elite-countdown]').forEach(initializeCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
